// extracted by mini-css-extract-plugin
export default {"postList":"PostList_postList__yne+o","tableHeader":"PostList_tableHeader__g4sKM"};